/**
 * Navigation Icons
 *
 * Icons used for navigation and core app features.
 *
 * Color scheme:
 * - Amber: Favorites (Star)
 * - Cyan: Recent items
 * - Red: Trash
 * - Gray: Settings, Search
 *
 * @module components/icons/NavigationIcons
 */

import {
  Star,
  Clock,
  Trash2,
  Settings,
  Search,
} from 'lucide-react';
import { cn } from '@loader/ui';

import type { IconProps } from './shared';
import { sizeClasses } from './shared';

/**
 * Star icon for favorites - Amber color
 */
export function FavoritesIcon({ className, size = 'sm' }: IconProps) {
  return (
    <Star
      className={cn(
        sizeClasses[size],
        'text-amber-500 dark:text-amber-400',
        className
      )}
    />
  );
}

/**
 * Clock icon for recent items - Cyan color
 */
export function RecentIcon({ className, size = 'sm' }: IconProps) {
  return (
    <Clock
      className={cn(
        sizeClasses[size],
        'text-cyan-500 dark:text-cyan-400',
        className
      )}
    />
  );
}

/**
 * Trash icon - Red color
 */
export function TrashIcon({ className, size = 'sm' }: IconProps) {
  return (
    <Trash2
      className={cn(
        sizeClasses[size],
        'text-red-500 dark:text-red-400',
        className
      )}
    />
  );
}

/**
 * Settings icon - Gray color
 */
export function SettingsIcon({ className, size = 'sm' }: IconProps) {
  return (
    <Settings
      className={cn(
        sizeClasses[size],
        'text-gray-500 dark:text-gray-400',
        className
      )}
    />
  );
}

/**
 * Search icon - Gray color
 */
export function SearchIcon({ className, size = 'sm' }: IconProps) {
  return (
    <Search
      className={cn(
        sizeClasses[size],
        'text-gray-500 dark:text-gray-400',
        className
      )}
    />
  );
}
